import { getM8AdminURL } from 'services/production/utils/getM8URL';
import { customFetch } from 'utils/http';

export const priorbankStatus = async (): Promise<boolean> => {
  const response = await customFetch(getM8AdminURL('priorbankStatus'));

  return response.ok;
};
